/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuTypeaheadContainer_viewer$ref = any;
export type SbSharedRefineMenuRadioSelectSearch_viewer$ref = any;
export type SbSharedRefineMenuRadioSelectSearch_viewer = {
    readonly " $fragmentRefs": SbSharedRefineMenuTypeaheadContainer_viewer$ref;
    readonly " $refType": SbSharedRefineMenuRadioSelectSearch_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuRadioSelectSearch_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '7f4ab4b9bb82a100a696e1ed031ed2e1';
export default node;
